// extracted by mini-css-extract-plugin
module.exports = {"root":"Background-module--root--bmfgT","backgroundImage":"Background-module--backgroundImage--rU4MO"};